const awsServicesDisplay: string[] = [
    "A4b",
    "Access Analyzer",
    "Acm Pca",
    "Acm",
    "Amplify",
    "Appconfig",
    "Appflow",
    "Appmesh",
    "Appstream",
    "Appsync",
    "Athena",
    "Auditmanager",
    "Autoscaling",
    "Backup",
    "Batch",
    "Braket",
    "Cassandra",
    "Chime",
    "Cloud9",
    "Clouddirectory",
    "Cloudfront",
    "Cloudhsm",
    "Cloudtrail",
    "Cloudwatch",
    "Codeartifact",
    "Codecommit",
    "Codedeploy",
    "Codeguru Profiler",
    "Codepipeline",
    "Codestar Connections",
    "Codestar",
    "Cognito Identity",
    "Cognito Idp",
    "Comprehend",
    "Config",
    "Connect",
    "Dataexchange",
    "Datapipeline",
    "Datasync",
    "Deepcomposer",
    "Detective",
    "Devicefarm",
    "Directconnect",
    "Dlm",
    "Dms",
    "Dynamodb",
    "Ec2",
    "Ecr",
    "Ecs",
    "Eks",
    "Elastic Inference",
    "Elasticache",
    "Elasticbeanstalk",
    "Elasticfilesystem",
    "Elasticloadbalancing",
    "Elasticmapreduce",
    "Emr Containers",
    "Es",
    "Events",
    "Firehose",
    "Fms",
    "Forecast",
    "Frauddetector",
    "Fsx",
    "Gamelift",
    "Glacier",
    "Globalaccelerator",
    "Glue",
    "Greengrass",
    "Groundstation",
    "Guardduty",
    "Iam",
    "Imagebuilder",
    "Inspector",
    "Iot1click",
    "Iot",
    "Iotanalytics",
    "Iotdeviceadvisor",
    "Iotevents",
    "Iotfleethub",
    "Iotsitewise",
    "Iottwinmaker",
    "Iotwireless",
    "Ivs",
    "Kafka",
    "Kendra",
    "Kinesis",
    "Kinesisanalytics",
    "Kms",
    "Lambda",
    "Lex",
    "License Manager",
    "Lightsail",
    "Logs",
    "Lookoutequipment",
    "Machinelearning",
    "Macie2",
    "Managedblockchain",
    "Mediaconnect",
    "Mediaconvert",
    "Medialive",
    "Mediapackage Vod",
    "Mediapackage",
    "Mediatailor",
    "Mobiletargeting",
    "Mq",
    "Neptune Graph",
    "Network Firewall",
    "Networkmanager",
    "Opsworks Cm",
    "Opsworks",
    "Organizations",
    "Outposts",
    "Qldb",
    "Quicksight",
    "Ram",
    "Rds",
    "Redshift",
    "Resource Explorer 2",
    "Resource Groups",
    "Robomaker",
    "Route53",
    "Route53domains",
    "Route53resolver",
    "S3",
    "Sagemaker",
    "Savingsplans",
    "Schemas",
    "Secretsmanager",
    "Securityhub",
    "Servicediscovery",
    "Servicequotas",
    "Ses",
    "Sns",
    "Sqs",
    "Ssm",
    "States",
    "Storagegateway",
    "Swf",
    "Synthetics",
    "Tag",
    "Transfer",
    "Waf Regional",
    "Waf",
    "Wafv2",
    "Worklink",
    "Workmail",
    "Workspaces",
    "Xray",
    "Kinesisvideo",
    "Redshift Serverless",
    "Route53 Recovery Control Config",
    "Route53 Recovery Readiness",
    "Ssm Contacts",
    "Ssm Incidents",
    "Vpc Lattice",
    "Workspaces Web"
];

export default awsServicesDisplay;